// extracted by mini-css-extract-plugin
module.exports = {"countdown":"_2evFWZ","pointer":"_3PwHU7","text":"_1S-zbQ","digits":"_1mq1NN"};